import { createStore } from 'vuex';
import app from './modules/app';
import applications from './modules/applications';
import landlordFiles from './modules/landlordFiles';
import tags from './modules/tags';

export default createStore({
  strict: true,
  modules: {
    app,
    applications,
    landlordFiles,
    tags
  }
});
